import { Combo } from './combo.model';
import { Profissionais } from './profissionais.model';
import { FuncaoExercidaHipoteses } from './funcao-exercida-hipoteses.model';
import { AnexoPrestacaoConta } from './anexo-prestacao-conta.model';
import { RelatorioAtividadesConhecimento } from './relatorio-atividades-conhecimento.model';
import { RelatorioAtividadesComissaoBanca } from 'app/entity/relatorio-atividades-comissao-banca.model';
import { RelatorioAtividadesDocencia } from 'app/entity/relatorio-atividades-docencia.model';
import { RelatorioAtividadesProducaoIntelectual } from 'app/entity/relatorio-atividades-producao-intelectual.model';
import { ResultadoPrestacaoConta } from './resultado-prestacao-conta.model';
import { FuncaoExercidaPrestacaoConta } from './funcao-exercida_prestacao_conta.model';

export class PrestacaoConta {
    public id: number;
    public id_situacao: number;
    public data_cadastro: Date;
    public cpf: string;
    public data_exclusao: Date;
    public ComboDto: string;
    public aceite: boolean;
    public codigo_controle: string;
    public nome_profissional: string;
    public registro: string; 
    public lotacao: string;
    public nome_situacao: string ;
    public data_conclusao: Date;


    public atividade_prestacao_conta: any[];
    public anexo_profissional_prestacao_conta: any[];
    public endereco_profissional_prestacao_conta: any[];
    public funcao_exercida_prestacao_conta: FuncaoExercidaPrestacaoConta[];
    public telefone_profissional_prestacao_conta: any[];
    public email_profissional_prestacao_conta: any[];
    public resultado_prestacao_conta: ResultadoPrestacaoConta[];
    public exercicio: ResultadoPrestacaoConta[];

}


// WEBPACK FOOTER //
// ./src/app/entity/prestacao-conta.model.ts